import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
// import ht from "../../Images/newWhiteLogo.png";
import ht from "../../Images/T_logo_rgb_n.svg";
import iskon from "../../Images/logo-iskon.svg";
import "../../Style/Login.css";
import Loading from "react-fullscreen-loading";
import { useTranslation } from "react-i18next";
import Footer from "../Common/Footer";

const Login = () => {
  const { login, validationMsg, setValidationMsg, keepLogged, setKeepLogged } =
    useContext(AuthContext);

  const [state, setState] = useState({
    username: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [passType, setPassType] = useState("password");
  const { t: translator } = useTranslation();

  useEffect(() => {
    document.body.id =
      window.REACT_APP_COLOR != "#eb7203" ? "login" : "login-iskon";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValidationMsg("");

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (state.username && state.password) {
      setTimeout(() => {
        login(state.username, state.password)
          .then((res) => {
            if (!res) setIsLoading(false);
            else setValidationMsg("Login-igor");
          })
          .catch((err) => {
            setValidationMsg("Igor");
            console.log(err);
          });
      }, 500);
    } else {
      setIsLoading(false);
      setValidationMsg("Login-ValidationMsg");
    }
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg brand-color p-0">
        <span className="navbar-brand pl-4">
          <img
            src={window.REACT_APP_VENDOR === "ht" ? ht : ht}
            alt="logo"
            id={`logo-login-${window.REACT_APP_VENDOR}`}
          />
        </span>
      </nav>
      <div id="login-body-wrapper">
        <div className="col-lg-4" id={`login-box-${window.REACT_APP_VENDOR}`}>
          <h5 className="text-center text-uppercase teleServiceName">
            <strong>{translator("Login-AndroidCashRegister")}</strong>
          </h5>
          <h1 className="text-center py-4 teleh1">
            {translator("Login-PleaseSignIn")}
          </h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                id="username"
                name="username"
                placeholder={translator("Login-Placeholder-UserName")}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <input
                type={passType}
                className="form-control"
                id="password"
                name="password"
                placeholder={translator("Login-Placeholder-Password")}
                onChange={handleChange}
              />
              <span
                className="show-pin-login"
                onMouseDown={() => setPassType("text")}
                onMouseUp={() => setPassType("password")}
                onMouseLeave={() => setPassType("password")}
                onTouchStart={() => setPassType("text")}
                onTouchCancel={() => setPassType("password")}
              >
                <i className="fas fa-eye text-dark"></i>
              </span>
            </div>
            <div className="form-group">
              <label className="labelCont">
                <input
                  type="checkbox"
                  checked={keepLogged}
                  onChange={() => setKeepLogged(!keepLogged)}
                />
                <span className="checkmark"></span>
              </label>
              <span className="keepLogged">
                {translator("Login-StayLoggedIn")}
              </span>
              <span className="float-right">
                <Link to="/forgot-password" className="teleLink">
                  {translator("Login-ForgotPassword")}
                </Link>
              </span>
            </div>
            <div className="text-center text-danger mb-2">
              <span>{translator(validationMsg)}</span>
            </div>
            <button
              id="loginBtn"
              type="submit"
              className="btn btn-primary w-100"
            >
              {translator("Login-Login")}
            </button>
          </form>
          <div className="text-center mt-4">
            <a
              className="teleLink"
              href="https://www.hrvatskitelekom.hr/poslovni/podrska-poslovni/ict"
              target="_blank"
            >
              {translator("Login-Help")}
            </a>
          </div>
        </div>
      </div>

      <Footer />
      <Loading
        loading={isLoading}
        background="rgba(60, 60, 60, 0.5)"
        loaderColor={window.REACT_APP_COLOR}
      />
    </div>
  );
};

export default Login;
